import { loadRemote, registerRemotes, } from "@module-federation/enhanced/runtime";
import { toMfManifestUrl } from "../mf-manifest.utils";
/**
 * Drop-in replacement for the two `@nx/angular/mf` helpers the host shell uses.
 *
 * The real `@nx/angular/mf` relies on Webpack runtime internals
 * (`__webpack_init_sharing__` / `__webpack_share_scopes__.default`), which do not exist
 * under Rspack. `@nx/webpack`'s Module Federation build already uses
 * `@module-federation/enhanced`, so the enhanced runtime share scope is present in both
 * bundlers and this implementation is a safe swap.
 *
 * Remotes are registered manifest-first: each remote URL is resolved to its `mf-manifest.json`
 * descriptor, which is the supported Module Federation 2.0 flow and the one the enhanced runtime
 * expects (see `toMfManifestUrl` for why a direct `remoteEntry.mjs` entry cannot be used).
 */
export function setRemoteDefinitions(remoteUrls) {
    const remotes = Object.entries(remoteUrls)
        .filter(([, rawUrl]) => !!rawUrl)
        .map(([name, rawUrl]) => ({
        name,
        entry: toMfManifestUrl(rawUrl),
    }));
    // The runtime's own "Failed to get manifest" warning does not say which remote failed,
    // so log the resolved descriptors once to make remote-loading problems diagnosable.
    console.log("[MF] Registered remotes (manifest-first):", remotes.map(({ name, entry }) => `${name} → ${entry}`));
    registerRemotes(remotes);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function loadRemoteModule(remoteName, exposedModule = "./Routes") {
    const moduleName = exposedModule.startsWith("./")
        ? exposedModule.slice(2)
        : exposedModule;
    const mod = await loadRemote(`${remoteName}/${moduleName}`);
    if (mod === null || mod === undefined) {
        throw new Error(`[MF] Failed to load remote module: ${remoteName}/${moduleName}`);
    }
    return mod;
}
//# sourceMappingURL=nx-mf-compat.js.map